import { render } from "./BasicTable.vue?vue&type=template&id=7f980b9c&scoped=true"
import script from "./BasicTable.vue?vue&type=script&lang=js"
export * from "./BasicTable.vue?vue&type=script&lang=js"

import "./BasicTable.vue?vue&type=style&index=0&id=7f980b9c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f980b9c"]])

export default __exports__